module.exports = __webpack_public_path__ + "media/images/sandbox/samus-601f1392cc1e678c149f181969d10c5d.png";